import { HtmlContentStatus } from 'constants/article-data'

const defineContentStatus = (
  isAuthorized: boolean,
  unregisteredAvailable?: boolean,
  recomendation?: any
) => {
  if (isAuthorized && recomendation?.type === 'QUESTIONNAIRE')
    return HtmlContentStatus.SHOW_QUESTIONNAIRE
  if (isAuthorized && recomendation?.type === 'WEBINAR') return HtmlContentStatus.SHOW_WEBINAR
  if (isAuthorized) return HtmlContentStatus.AUTH
  if (unregisteredAvailable) return HtmlContentStatus.SHOW_REG_BANNER
  return HtmlContentStatus.HIDE_CONTENT
}
export { defineContentStatus }
